import React from 'react'
import {message} from 'antd'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import SortableList from 'components/shared/SortableList'

import './index.scss'

const ESTATES_QUERY = gql`
  query PhotoOrderPreference {
    viewer {
      id
      photoOrderPreference {
        inherited
        edges {
          cursor
          node {
            id
            name
          }
        }
      }
    }
  }
`

const setPhotoOrderPreferenceMutation = gql`
  mutation SetPhotoOrderPreference($input: SetPhotoOrderPreferenceInput!) {
    SetPhotoOrderPreference(input: $input) {
      viewer {
        id
      }
    }
  }
`

const PhotoOrderPreference = () => {
  const updatePreference = (mutation, photoLabels) => {
    const photoLabelIds = photoLabels.map(l => l.id)

    return mutation({
      variables: {
        input: {
          photoLabelIds,
        },
      }
    })
    .catch(() => {
      message.error('En feil oppstod ved endring av romrekkefølge. Vennligst forsøk på nytt eller kontakt EFKT kundeservice.')
    })
  }


  return (
    <div className="photo-order-preference">
      <Heading level={2}>Romrekkefølge</Heading>
      <Mutation mutation={setPhotoOrderPreferenceMutation}>
        {(setPhotoOrderPreference) => (
          <Query
            inlineError
            query={ESTATES_QUERY}
          >
            {({getData, loading, refetch}) => {
              if (!loading) {
                const {edges: orderEdges, inherited} = getData('viewer.photoOrderPreference')
                const photoLabels = orderEdges.map(e => e.node)

                const labelsUpdated = (photoLabels) =>
                  updatePreference(setPhotoOrderPreference, photoLabels)
                    .then(refetch)

                const reset = () => labelsUpdated([])

                const canReset = !inherited

                return (
                  <>
                    <p>
                      Bildene vises i følgende rekkefølge.<br />
                      Dra og slipp for å endre romrekkefølgen på bildeleveranser.
                    </p>
                    <SortableList
                      labels={photoLabels}
                      onUpdate={labelsUpdated}
                      renderLabel={label => label.name}
                    />
                    {canReset &&
                      <div className="reset-container">
                        <Button
                          onClick={reset}
                        >
                          Tilbakestill
                        </Button>
                      </div>
                    }
                  </>
                )
              }

              return null
            }}
          </Query>
        )}
      </Mutation>
    </div>
  )
}

export default PhotoOrderPreference
